import Button from '@material-ui/core/Button';
import Icon from '@material-ui/core/Icon';
import PermissionHide from 'components/PermissionHide';
import React from 'react';
import { Link } from 'react-router-dom';

const EditButton = ({ id, parentId, disabled, onClick }: { id: string; parentId?: string; disabled?: boolean; onClick?: () => void }) => {
  const isChild = !!parentId;
  const finalRoute = isChild ? `/producer/product/editproduct/${parentId}/${id}` : `/producer/product/editproduct/${id}`;

  const handleClick = () => {
    if (onClick) onClick();
  };

  return (
    <PermissionHide action='myeduzz:meus-produtos:editar'>
      <Link to={finalRoute}>
        <Button
          id='quickview-product-edit-button'
          size='small'
          onClick={handleClick}
          style={{
            color: disabled ? '#ddd' : '#596375',
            fontSize: 12,
            fontWeight: 600,
          }}
          disabled={disabled}
        >
          <Icon style={{ fontSize: 12, color: '#596375', marginRight: '0.5rem' }}>edit</Icon>
          Editar
        </Button>
      </Link>
    </PermissionHide>
  );
};

export default EditButton;
